module.exports = "<p>\n  location-info works!\n</p>\n"